<section class="ced-div" aria-label="Divergências do pedido">
  <div class="ced-div-titulo">
    <span class="ced-div-titulo-icone"><mat-icon class="material-symbols-outlined">error</mat-icon></span>
    <h3>Divergências do pedido</h3>
  </div>
  <p class="ced-div-apoio">O pedido saiu do fluxo por uma divergência. Resolva pelo vínculo da nota ou pela conferência e escolha o desfecho.</p>

  @if (divergencias.length) {
  <div class="ced-div-lista">
    @for (divergencia of divergencias; track divergencia.idCompraOcorrencia) {
    <div class="ced-div-cartao">
      <div class="ced-div-cartao-topo">
        <mat-icon class="material-symbols-outlined ced-div-cartao-icone">{{ divergencia.isConferencia ? 'fact_check' : 'rule' }}</mat-icon>
        <span class="ced-div-cartao-origem">
          {{ divergencia.isConferencia ? 'Problema registrado na conferência' : 'Divergência apurada no vínculo da NF' }}
        </span>
        @if (divergencia.tipo) { <span class="status-badge badge-vermelho ced-div-tipo">{{ divergencia.tipo }}</span> }
      </div>
      <div class="ced-div-cartao-corpo">
        <div class="ced-div-cartao-texto">{{ divergencia.texto }}</div>
        @if (divergencia.referencia) { <div class="ced-div-cartao-info">Referência: {{ divergencia.referencia }}</div> }
        @if (divergencia.quantidade != null) {
        <div class="ced-div-cartao-info">Quantidade com problema: {{ divergencia.quantidade | number: '1.0-4' }}</div>
        }
      </div>
      <div class="ced-div-cartao-rodape">
        <span>{{ divergencia.autor }}</span>
        <span class="ced-div-cartao-data">{{ divergencia.dataOcorrencia | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>
    </div>
    }
  </div>
  } @else {
  <app-alert-card type="neutral">
    Nenhuma divergência registrada no histórico. O pedido foi movido manualmente para esta etapa.
  </app-alert-card>
  }

  <div class="ced-div-desfecho">
    <div class="ced-div-desfecho-titulo">Desfecho</div>
    <p class="ced-div-desfecho-texto">
      @if (temDivergenciaVinculo) {
      Aceitar e seguir ajusta o preço e o saldo do pedido ao da NF-e e segue para Pedido Faturado. Rever vínculo
      reabre o vínculo da NF para corrigir.
      }
      @if (temDivergenciaConferencia) {
      Aceitar e finalizar segue para Finalizado e libera o lançamento de estoque e contas da nota. Voltar para
      Conferência permite recontar.
      }
      @if (!motivoBloqueio(desfechoEnum.Cancelar)) {
      Recusar cancela o pedido, e a NF segue a regra da etapa Cancelado.
      }
    </p>
    <div class="ced-div-desfecho-acoes">
      @if (temDivergenciaVinculo) {
      <span [matTooltip]="motivoBloqueio(desfechoEnum.AceitarSeguir) || 'Ajusta preço/saldo do pedido ao da NF-e e segue para Pedido Faturado'">
        <button mat-flat-button type="button" class="btn-primary"
          [disabled]="!!motivoBloqueio(desfechoEnum.AceitarSeguir)" (click)="escolher(desfechoEnum.AceitarSeguir)">
          <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
          Aceitar e seguir
        </button>
      </span>
      <span [matTooltip]="motivoBloqueio(desfechoEnum.ReverVinculo)" [matTooltipDisabled]="!motivoBloqueio(desfechoEnum.ReverVinculo)">
        <button mat-stroked-button type="button" class="btn-secondary"
          [disabled]="!!motivoBloqueio(desfechoEnum.ReverVinculo)" (click)="escolher(desfechoEnum.ReverVinculo)">
          <mat-icon class="material-symbols-outlined">link</mat-icon>
          Rever vínculo
        </button>
      </span>
      }
      @if (temDivergenciaConferencia) {
      <span [matTooltip]="motivoBloqueio(desfechoEnum.Finalizar)" [matTooltipDisabled]="!motivoBloqueio(desfechoEnum.Finalizar)">
        <button mat-flat-button type="button" class="btn-primary"
          [disabled]="!!motivoBloqueio(desfechoEnum.Finalizar)" (click)="escolher(desfechoEnum.Finalizar)">
          <mat-icon class="material-symbols-outlined">check_circle</mat-icon>
          Aceitar e finalizar
        </button>
      </span>
      <span [matTooltip]="motivoBloqueio(desfechoEnum.VoltarConferencia)"
        [matTooltipDisabled]="!motivoBloqueio(desfechoEnum.VoltarConferencia)">
        <button mat-stroked-button type="button" class="btn-secondary"
          [disabled]="!!motivoBloqueio(desfechoEnum.VoltarConferencia)" (click)="escolher(desfechoEnum.VoltarConferencia)">
          <mat-icon class="material-symbols-outlined">undo</mat-icon>
          Voltar para Conferência
        </button>
      </span>
      }
      <span [matTooltip]="motivoBloqueio(desfechoEnum.Cancelar)" [matTooltipDisabled]="!motivoBloqueio(desfechoEnum.Cancelar)">
        <button mat-stroked-button type="button" class="btn-secondary ced-div-recusar"
          [disabled]="!!motivoBloqueio(desfechoEnum.Cancelar)" (click)="escolher(desfechoEnum.Cancelar)">
          <mat-icon class="material-symbols-outlined">block</mat-icon>
          Recusar e cancelar
        </button>
      </span>
    </div>
  </div>
</section>
